<lib-header [pageTitle]="'common.title'" [showLanguageToggle]="true"></lib-header>
<div class="content">
    <lib-alert-panel *ngIf="showSessionTimeout" [alertType]="'sessionWarning'" (sessionEvent)="extendSession($event)"
        [alertTitle]="'common.alerts.sessionTimeoutWarning.title'"
        [alertMessage]="['common.alerts.sessionTimeoutWarning.sub-title']"></lib-alert-panel>
    <router-outlet></router-outlet>
</div>
<lib-footer></lib-footer>